export default __webpack_public_path__ + "static/media/individual-account-host.12f08be3.png";